import { __decorate } from "tslib";
import { ImageFrame } from './ImageFrame';
import { SerializableObject } from '@openhps/core';
let VideoFrame = class VideoFrame extends ImageFrame {
};
VideoFrame = __decorate([
    SerializableObject()
], VideoFrame);
export { VideoFrame };
//# sourceMappingURL=VideoFrame.js.map